import { createFileRoute } from '@tanstack/react-router'
import { ProductionDashboard } from 'pages/productionDashboard/ProductionDashboard'

import { productionDashboardConfigSearchParams } from './-searchParams'

function RouteComponent() {
  const { orgId, siteId, configId } = Route.useSearch()

  return (
    <ProductionDashboard orgId={orgId} siteId={siteId} configId={configId} />
  )
}

export const Route = createFileRoute('/production-dashboard/config')({
  component: RouteComponent,
  validateSearch: productionDashboardConfigSearchParams,
})
